// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderHL7Message,
    ProviderHL7SortType,
    SupportCreateReprocessHl7Payload,
    SupportHL7Message,
    SupportHL7SortType,
    SupportCreateReprocessHl7PayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderHL7MessageFromJSON,
    SupportHL7MessageFromJSON,
} from '../models';

export interface Hl7AggregateMessageRequest {
    body?: string;
}

export interface ListProviderHL7MessagesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderHL7MessagesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterClaimControlNumber?: Array<string>;
    filterFromDos?: Array<string>;
    filterPatientExternalId?: Array<string>;
    filterPatientFirstName?: Array<string>;
    filterPatientLastName?: Array<string>;
    filterPatientDob?: Array<string>;
    sort?: Array<ProviderHL7SortType>;
}

export interface ListSupportHL7MessagesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportHL7MessagesOrderEnum>;
    filterActive?: string;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterClaimControlNumber?: Array<string>;
    filterFromDos?: Array<string>;
    filterPatientExternalId?: Array<string>;
    filterPatientFirstName?: Array<string>;
    filterPatientLastName?: Array<string>;
    filterPatientDob?: Array<string>;
    sort?: Array<SupportHL7SortType>;
}

export interface ReprocessHL7MessageRequest {
    id: string;
    supportCreateReprocessHl7Payload?: SupportCreateReprocessHl7Payload;
}

/**
 * no description
 */
export class HL7Api extends runtime.BaseAPI {

    /**
     * Accepts ADT and MDM messages to be aggregated together to create a claim
     * Save HL7 messages to be processed into claims
     */
    async hl7AggregateMessageRaw(requestParameters: Hl7AggregateMessageRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/hl7/aggregate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Accepts ADT and MDM messages to be aggregated together to create a claim
     * Save HL7 messages to be processed into claims
     */
    async hl7AggregateMessage(requestParameters: Hl7AggregateMessageRequest): Promise<string> {
        const response = await this.hl7AggregateMessageRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of HL7s
     * Get a list of Hl7s
     */
    async listProviderHL7MessagesRaw(requestParameters: ListProviderHL7MessagesRequest): Promise<runtime.ApiResponse<Array<ProviderHL7Message>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterClaimControlNumber) {
            queryParameters['filterClaimControlNumber'] = requestParameters.filterClaimControlNumber;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterPatientExternalId) {
            queryParameters['filterPatientExternalId'] = requestParameters.filterPatientExternalId;
        }

        if (requestParameters.filterPatientFirstName) {
            queryParameters['filterPatientFirstName'] = requestParameters.filterPatientFirstName;
        }

        if (requestParameters.filterPatientLastName) {
            queryParameters['filterPatientLastName'] = requestParameters.filterPatientLastName;
        }

        if (requestParameters.filterPatientDob) {
            queryParameters['filterPatientDob'] = requestParameters.filterPatientDob;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:hl7"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderHL7MessageFromJSON));
    }

    /**
     * Gets a list of HL7s
     * Get a list of Hl7s
     */
    async listProviderHL7Messages(requestParameters: ListProviderHL7MessagesRequest): Promise<Array<ProviderHL7Message>> {
        const response = await this.listProviderHL7MessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of HL7s
     * Get a list of Hl7s
     */
    async listSupportHL7MessagesRaw(requestParameters: ListSupportHL7MessagesRequest): Promise<runtime.ApiResponse<Array<SupportHL7Message>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterClaimControlNumber) {
            queryParameters['filterClaimControlNumber'] = requestParameters.filterClaimControlNumber;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterPatientExternalId) {
            queryParameters['filterPatientExternalId'] = requestParameters.filterPatientExternalId;
        }

        if (requestParameters.filterPatientFirstName) {
            queryParameters['filterPatientFirstName'] = requestParameters.filterPatientFirstName;
        }

        if (requestParameters.filterPatientLastName) {
            queryParameters['filterPatientLastName'] = requestParameters.filterPatientLastName;
        }

        if (requestParameters.filterPatientDob) {
            queryParameters['filterPatientDob'] = requestParameters.filterPatientDob;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:hl7", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/hl7`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportHL7MessageFromJSON));
    }

    /**
     * Gets a list of HL7s
     * Get a list of Hl7s
     */
    async listSupportHL7Messages(requestParameters: ListSupportHL7MessagesRequest): Promise<Array<SupportHL7Message>> {
        const response = await this.listSupportHL7MessagesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reprocess existing HL7 message
     * Reprocess existing HL7 message
     */
    async reprocessHL7MessageRaw(requestParameters: ReprocessHL7MessageRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling reprocessHL7Message.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:hl7", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/hl7/{id}/reprocess`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateReprocessHl7PayloadToJSON(requestParameters['supportCreateReprocessHl7Payload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reprocess existing HL7 message
     * Reprocess existing HL7 message
     */
    async reprocessHL7Message(requestParameters: ReprocessHL7MessageRequest): Promise<ObjectNoResponse> {
        const response = await this.reprocessHL7MessageRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderHL7MessagesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportHL7MessagesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
